// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/common/payment.proto

/* eslint-disable */

/**
 * Represents a currency amount according to
 * https://www.w3.org/TR/payment-request/#paymentcurrencyamount-dictionary.
 */
export interface ApiCurrencyAmount {
  /** The ISO 4217 currency code of the currency in which `value` is denoted. */
  readonly currency: string;
  /** The value in major units of `currency`, as a decimal string. */
  readonly value: string;
}

export const ApiCurrencyAmount: MessageFns<ApiCurrencyAmount> = {
  fromJSON(object: any): ApiCurrencyAmount {
    return {
      currency: isSet(object.currency) ? globalThis.String(object.currency) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: ApiCurrencyAmount): unknown {
    const obj: any = {};
    if (message.currency !== undefined && message.currency !== null) {
      obj.currency = message.currency;
    }
    if (message.value !== undefined && message.value !== null) {
      obj.value = message.value;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
